import { createApp } from 'vue'
import ThemeApp from "../app/ThemeApp.vue";
import AppUtil from "../app/utils/AppUtil";

import UIUtil from "../app/utils/UIUtil";
import ColorUtil from "../app/utils/ColorUtil";
import ThemeUtil from "../app/utils/ThemeUtil";
import FontUtil from "../app/utils/FontUtil";
import NotificationUtil from "../app/utils/NotificationUtil";
import Rails from "@rails/ujs";
window.Rails = Rails;

import webase from "../app/model"
window.webase = webase
webase.utils.app = new AppUtil()
webase.utils.ui = new UIUtil()
webase.utils.color = new ColorUtil()
webase.utils.theme = new ThemeUtil()
webase.utils.font = new FontUtil()
webase.utils.notification = new NotificationUtil()

if(WEBASE_SYSTEM_ID) {
    webase.model.auth_token = WEBASE_SYSTEM_ID
    webase.model.user_id = WEBASE_INIT_ID
}

document.addEventListener('DOMContentLoaded', () => {
    const app = createApp(ThemeApp)
    app.mount('#app')
})